<template>
    <form-dialog
      :dialogVisible="themeDialog"
      @closeDialog="closeAdd"
      :title="'增加主题'"
    >
      <div class="form-item">
          <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="主题名称" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="主题描述" prop="content">
                <el-input type="textarea" v-model="form.content"></el-input>
            </el-form-item>
          </el-form>
      </div>
      <div class="buttons">
        <el-button type="primary" @click="confirm()" round>确认</el-button>
        <el-button @click="cancel" round>取消</el-button>
      </div>
    </form-dialog>
  </template>
  
  <script>
  import FormDialog from "@/components/basics/FormDialog";
  
  export default {
    name: "ThemeEdit",
    props: {
      themeDialog: {
        type: Boolean,
        required: true,
        default: false,
      },
      type: {
        type: Number,
        default: 1
      },
      addEdit: {
        type: String,
        default: "ADD"
      },
      editData: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        form: {
          name: "",
          content: "",
        },
        rules: {
          name: [{ required: true, message: "请输入主题名称", trigger: "blur" }],
        }
      };
    },
    methods: {
      closeAdd(isUpdate) {
        this.$emit("closeThemeDialog",isUpdate);
        this.$refs.form.resetFields()
      },
      async confirm() {
        this.$refs.form.validate(validate => {
          if(validate) {
            if(this.addEdit === "ADD") {
              this.$http.post('/admin/template/addTheme',{
                group_id: this.$cookies.get("group_id"),
                type: this.type,
                name: this.form.name,
                description: this.form.content
              }).then(() => {
                this.closeAdd(true)
              })
            }else{
              this.$http.post('/admin/template/editTheme',{
                id: this.editData.id,
                name: this.form.name,
                description: this.form.content
            },() => {
              this.closeAdd(true)
            })
          }
          }
        })
      },
      cancel() {
        this.closeAdd(false);
      },
    },
    created(){
      if(Object.keys(this.editData).length){
        this.form.name = this.editData.name;
        this.form.content = this.editData.description;
      }
    },
    watch: {
      editData(n){
        if(Object.keys(n).length){
          this.form.name = n.name;
          this.form.content = n.description;
        }
      }
    },
    components: {
      FormDialog,
    },
  };
  </script>
  
  <style lang="scss" scoped>
    .form-item {
      padding-right: 20px;
    }
    .buttons {
      text-align: center;
    }
  </style>